import { Component, HostListener, Input, NgZone, OnInit, Renderer2 } from "@angular/core";
import { Router } from "@angular/router";
import { REPORTE_PERIODOS_INFORME_PENSION } from "@constants/informe-pensiones.constants";
import { URL_ESTIMADOR_PENSION, URL_PERFIL_RIESGO } from "@constants/url.constant";
import { ModalService } from "@services/modal/modal.service";
import { StorageService } from "@services/storage/storage.service";
import { IReporteDisponibleInformePension } from "@shared/common/interfaces/reporte-disponible-informe-pension.interface";
import { IPropiedadesVideoIPPResponse } from "@shared/common/interfaces/video-ipp.interface";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-modal-video-ipp",
  standalone: false,
  templateUrl: "./modal-video-ipp.component.html",
  styleUrls: ["./modal-video-ipp.component.scss"]
})
export class ModalVideoIppComponent implements OnInit {
  @Input() data: IPropiedadesVideoIPPResponse | null = null;

  mostrarModalVideo = false;
  mostrarBotonCerrar = false; // Controla si se muestra el botón de cerrar flotante
  codigoAdjuntoVideo: string = environment.CODIGO_ADJUNTO_VIDEO_IPP;
  Ultimoperiodo: string = "";

  constructor(
    private readonly renderer: Renderer2,
    private readonly modalService: ModalService,
    private readonly storageService: StorageService,
    private readonly ngZone: NgZone,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    void this.getPeriodosDisponibles();

    setTimeout(() => {
      (globalThis as any).onIndivideoReady = (smartPlayer: any) => {
        this.inicializarConData(smartPlayer);
      };

      this.cargarScriptIndivideo();
    }, 100);
  }
  async getPeriodosDisponibles() {
    const periodosDisponibles: IReporteDisponibleInformePension =
      await this.storageService.get(REPORTE_PERIODOS_INFORME_PENSION);
    this.Ultimoperiodo = periodosDisponibles.periodos[0];
  }

  private inicializarConData(smartPlayer: any) {
    if (!this.data) return;

    const userData = { ...this.data };

    const playerOptions = {
      view: {
        mode: "inline",
        container: "#individeo-player-container",
        resize: true,
      },
      ui: {
        controls: {
          autoHide: false,
          visible: true,
        },
      },
      playback: {
        autoplay: true,
        playsInline: true,
      },
    };

    // Inicializar con la data del input y las opciones técnicas
    smartPlayer.initIndivideo(userData, playerOptions);
  }

  private cargarScriptIndivideo() {
    const script = this.renderer.createElement("script");
    script.src = environment.URL_INDIVIDEO_IPP;

    script.dataset.ivOnReady = "onIndivideoReady";
    script.dataset.ivAutoInit = "false";
    script.dataset.ivAttachmentCode = this.codigoAdjuntoVideo;
    script.dataset.ivLang = "es-CL";
    script.dataset.ivEnableEmulateFullscreen = "true";
    script.dataset.ivUseBranding = "false";

    const videoContainer = document.getElementById(
      "individeo-player-container",
    );

    this.renderer.appendChild(videoContainer, script);
  }

  iconoCerrar() {
    this.modalService.closeModal();
  }

  @HostListener("window:message", ["$event"])
  onMessage(event: MessageEvent) {
    this.ngZone.run(() => {
      // IMPORTANTE: Filtrar por el origen para seguridad
      if (!event.origin.includes("individeo")) return;

      try {
        // IndiVideo envía algunos mensajes como strings con formato "evento:::data:::info"
        // y otros como objetos JSON. Necesitamos manejar ambos casos.

        // Si es un string que contiene ":::", ignorarlo (son eventos internos de IndiVideo)
        if (typeof event.data === "string" && event.data.includes(":::")) {
          return; // Ignorar silenciosamente estos mensajes
        }

        // Los eventos de IndiVideo suelen venir como un objeto JSON o string
        const data =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        // **CRÍTICO**: Detectar eventos de CTA y ejecutar lógica personalizada
        if (data.event === "onCTA" || data.event === "onMediaCTA") {

          // Extraer información del botón desde details.ctaName
          const buttonLabel =
            data.details?.ctaName ||
            data.details?.label ||
            data.details?.title ||
            data.details?.text ||
            data.details?.name ||
            data.label ||
            data.buttonLabel;

          // Construir objeto completo del evento CTA
          const ctaEventData = {
            label: buttonLabel,
            ctaName: data.details?.ctaName,
            details: data.details,
            attachmentCode: data.attachmentCode,
            mediaCode: data.mediaCode,
          };

          // Ejecutar lógica personalizada directamente
          this.handleButtonClick(ctaEventData);
        }
      } catch (e) {
        console.warn("Mensaje recibido no es JSON, ignorando:", e);
      }
    });
  }

  handleButtonClick(ctaData: any) {
    const buttonLabel = ctaData.label || ctaData.ctaName;

    // Detectar el botón "Simula tu Pensión"
    if (
      buttonLabel === "Simula tu Pensión" ||
      buttonLabel?.toLowerCase().includes("simula") ||
      buttonLabel?.toLowerCase().includes("simulación")
    ) {
      this.router.navigate([URL_ESTIMADOR_PENSION]);
    }
    // Detectar el botón "Define tu Perfil"
    else if (
      buttonLabel === "Define tu Perfil" ||
      buttonLabel?.toLowerCase().includes("perfil")
    ) {
      this.router.navigate([URL_PERFIL_RIESGO]);
    }
  }
}
